import sum from './sum'

const items = [
  {
    name: 'crib',
    label: 'Crib',
    description: 'Cribs typically range anywhere from $150-$1000.',
    enabled: true,
    value: 300,
  },
  {
    name: 'changingTable',
    label: 'Changing table',
    description: 'Changing tables typically range anywhere from $75-$300.',
    enabled: true,
    value: 125,
  },
  {
    name: 'bassinet',
    label: 'Bassinet',
    description: 'Bassinets typically range anywhere from $40-$100.',
    enabled: true,
    value: 75,
  },
  {
    name: 'beddingAndBlankets',
    label: 'Bedding and blankets',
    description: 'Bedding and blankets typically range anywhere from $50-$200.',
    enabled: true,
    value: 125,
  },
  {
    name: 'decorations',
    label: 'Decorations',
    description: 'Decorations for the baby room typically range anywhere from $100-$500.',
    enabled: true,
    value: 200,
  },
  {
    name: 'babyMonitor',
    label: 'Baby monitor',
    description: 'Baby monitors typically range anywhere from $25 - $200.',
    enabled: true,
    value: 50,
  },
]

export default {
  name: 'babyRoom',
  label: 'Baby room',
  enabled: false,
  value: sum(items),
  on: false,
  items,
}
